import {observable, action, runInAction} from 'mobx'
import {json} from '../../../utils/ajax'
import {handleSearchAndPage, ValueObjToObj, setStore} from "../../../utils/Utils";
import {message} from "antd";

class TaskManagement {

    @observable loading         //任务管理列表数据loading
    @observable taskManagementList  //任务管理列表数据
    @observable pagination      //分页
    @observable searchFields    //搜索值绑定

    constructor() {
        this.loading = false
        this.taskManagementList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {
            fileName: '',
        }
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**初始化页面*yg**/
    @action
    initTaskManagementPage = async (page) => {
        this.loading = true
        let searchResult = handleSearchAndPage(page, this.pagination, this.searchFields)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/page/searchs`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.taskManagementList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements?res.totalElements:0} 条`
            }
            this.loading = false
        })
    }

    /*** 绑定主页面搜索框值****/
    @action
    onFormField = (changeFields, fields) => {
        const change = ValueObjToObj(changeFields)
        this[fields] = {...this[fields], ...change}
    }

    /**清空搜索**/
    @action
    searchReset = () => {
        this.searchFields = {
            fileName: ''
        }
        this.initTaskManagementPage()
    }

    /**
     * 上传车型制造明细附件
     * @returns {Promise<void>}
     */
    @action
    saveEnclosure=async(fileList)=>{
        this.loading = true
        let list = {
            fileUrl:fileList.file.response,
            fileName:fileList.file.name,
            handelStatus:'0',
            fileType:'0'
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/insert`,list)
        runInAction(() => {
            this.initTaskManagementPage()
            this.loading = false
        })
    }

    /**
     * 上传非装车件明细附件
     * @returns {Promise<void>}
     */
    @action
    saveLevelEnclosure=async(fileList)=>{
        this.loading = true
        let list = {
            fileUrl:fileList.file.response,
            fileName:fileList.file.name,
            handelStatus:'0',
            fileType:'1'
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/insert`,list)
        runInAction(() => {
            this.initTaskManagementPage()
            this.loading = false
        })
    }

    @action
    saveBaBomEnclosure = async(fileList) => {
        this.loading = true
        let list = {
            fileUrl:fileList.file.response,
            fileName:fileList.file.name,
            handelStatus:'0',
            fileType:'2'
        }
        await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/insert`,list)
        runInAction(() => {
            this.initTaskManagementPage()
            this.loading = false
        })
    }

    /**处理**/
    @action
    isProcess = async (id) => {
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/checkIfThereIsAFileBeingProcessed`)
        if (res === 1) {
            runInAction(() => {
                this.loading = false
                message.warning('文件处理中，请耐心等待！')
            })
            return
        }
        json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/taskHandel/${id}`)
        runInAction(() => {
            message.warning('文件处理中，请耐心等待！')
        })
        setTimeout(() => {
            this.loading = false
            this.initTaskManagementPage()
        },2000)
    }

    /**删除**/
    @action
    deleteId = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/file-handel/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        runInAction(() => {
            this.loading = false
            this.initTaskManagementPage()
        })
    }
}

export default new TaskManagement()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/TaskManagement/store.js